import { useRecoilState } from 'recoil'

import { globalSnackbarAtom } from '@/recoil/atoms'

export const useGlobalSnackbarStore = () => {
    /** @type {[GlobalSnackbarAtom, SetterOrUpdater<GlobalSnackbarAtom>]} */
    const [globalSnackbar, setGlobalSnackbar] =
        useRecoilState(globalSnackbarAtom)

    /**
     * Initialise the setter of show value.
     * @param {SetterOrUpdater<boolean>} setShow Setter to show global snackbar
     * @return {void}
     */
    const initialiseGlobalSnackbar = (setShow) => {
        setGlobalSnackbar((oldGlobalSnackbar) => ({
            ...oldGlobalSnackbar,
            setShow,
        }))
    }

    /**
     * Display the global snackbar depending on the given data.
     * @param {GlobalSnackbarAtom['variant']} variant Value of the variant
     * @param {GlobalSnackbarAtom['text']} text Text to display
     * @return {void}
     */
    const showGlobalSnackbar = (variant, text) => {
        setGlobalSnackbar((oldGlobalSnackbar) => ({
            ...oldGlobalSnackbar,
            variant,
            text,
        }))

        globalSnackbar.setShow(true)
    }

    return {
        initialiseGlobalSnackbar,
        showGlobalSnackbar,
    }
}
